import { Button } from '@progress/kendo-react-buttons';
import { Form, FormElement, FormRenderProps, FormValidatorType } from '@progress/kendo-react-form';
import { Col, Row } from 'react-bootstrap';
import { CommonResources } from '../../../config/CommonResources';
import { EditionMode } from '../../../config/Constants';
import useAppRoutes from '../../helpers/RouteHook';
import { EntityType, EntityTypeProps } from '../../services/GraphQLModel';
import { AuditBox } from '../boxes/FieldBox';
import { IFormPageProps } from './ViewPanel';

export interface IFormPanelProps<T extends EntityTypeProps> extends IFormPageProps<T> {
  validator?: FormValidatorType | undefined;
  header?: () => React.ReactElement;
  type: EntityType;
  getElements: (formRenderProps: FormRenderProps) => React.ReactElement;
}
export function FormPanel<T extends EntityTypeProps>(props: IFormPanelProps<T>): React.ReactElement {
  const { getConfig } = useAppRoutes();
  const handleSubmit = (dataItem: any) => props.callBackSubmit(dataItem);
  const formHeader = () => {
    switch (props.editionMode) {
      case EditionMode.Create:
        return (
          <>
            <h3>
              {CommonResources.Form_CreationTitle}
              <b>{getConfig(props.type)?.display}</b>
            </h3>
            <p>{CommonResources.Form_CreationIntro}</p>
          </>
        );
      default:
        return <h3 className="mb-0">{props.initialValues.display}</h3>;
    }
  };
  return (
    <Form
      onSubmit={handleSubmit}
      validator={props.validator}
      initialValues={props.initialValues}
      render={(formRenderProps) => (
        <FormElement style={{ width: '100%' }}>
          <fieldset className={'k-form-fieldset'}>
            <>
              {props.header ? props.header() : formHeader()}
              {props.getElements(formRenderProps)}
            </>
          </fieldset>
          {props.editionMode === EditionMode.Update && (
            <AuditBox
              modifiedBy={formRenderProps.valueGetter('modifiedBy')}
              modifiedOn={formRenderProps.valueGetter('modifiedOn')}
              createdBy={formRenderProps.valueGetter('createdBy')}
              createdOn={formRenderProps.valueGetter('createdOn')}
            />
          )}
          <Row>
            <Col className= "form-action-buttons">
              <Button
                type="button"
                fillMode="flat"
                className="me-1"
                onClick={() => {
                  formRenderProps.onFormReset();
                  props.callBackCancel();
                }}
              >
                {CommonResources.Button_Cancel}
              </Button>
              <Button type={'submit'} themeColor="primary" disabled={!formRenderProps.allowSubmit}>
                {CommonResources.Button_Save}
              </Button>
            </Col>
          </Row>
        </FormElement>
      )}
    />
  );
}
